<template>
  <!-- Render a replacement block for each "WhatIfBlock" overlay -->
  <div v-for="block in WhatIfBlocks" :style="block.style">
    
    <!-- This is a placeholder button replacing the WhatIf block visually -->
    <!-- You can swap this with the actual <WhatIf /> component if needed -->
    <Button 
      :label = "'What If'"
      :to = "'/what_if'"
      :version = "'primary'"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import type { CSSProperties } from 'vue';

import WhatIf from '@/views/SitePages/WhatIf.vue';
import Button from '@/components/ComponentLibrary/Button.vue';

// Reactive array to store dynamically generated block overlay styles
const WhatIfBlocks = ref<Array<{ style: CSSProperties }>>([]);

// Attach event listener after the component is mounted
// This listens for a custom event indicating that the page content is loaded
document.addEventListener('body_content_loaded', () => {
  replaceWhatIfBlocks();
});

// Function to find all .page_frame elements and overlay them with interactive blocks
function replaceWhatIfBlocks() {
  // Get all DOM elements with the class 'page_frame'
  const blocks = document.getElementsByClassName('page_frame');

  // Create overlay block styles based on each element's position and size
  let whatIfBlocks = Array.from(blocks).map((block) => {
    const rect = block.getBoundingClientRect();
    return {
      style: {
        position: 'absolute',
        top: `${rect.top}px`,
        left: `${rect.left}px`,
        width: `${rect.width}px`,
        height: `${rect.height}px`,
        maxHeight : `${rect.height}px !important`,
        maxWidth: `${rect.width}px !important`,
        zIndex: 1000,
        pointerEvents: 'auto',
      } as CSSProperties,
    };
  });

  // Hide the original blocks without removing them from layout
  Array.from(blocks).forEach((block) => {
    (block as HTMLElement).style.visibility = 'hidden';
  });

  // Save the overlay styles into the reactive array to be rendered
  WhatIfBlocks.value = whatIfBlocks;
}
</script>